import WebSocket from 'ws';
import type { WebSocketLike } from './types';

/**
 * Creates a WebSocket instance for Node.js using the ws package
 */
export function createWebSocket(url: string): WebSocketLike {
  return new WebSocket(url) as WebSocketLike;
}
